<template>
  <div @click="coverClose" :style="[style]" class="allScreen"></div>
</template>

<script>
export default {
  data: function () {
    return {
      isShow: false,
      style: {
        opacity: this.opacity,
        zIndex: this.zIndex
      }
    }
  },
  props: {
    opacity: {
      type: Number,
      default: 0.88
    },
    zIndex: {
      type: Number,
      default: 999998
    }
  },
  methods: {
    coverClose () {
      this.$emit('close', this.$el)
    }
  }
}
</script>

<style scoped>
.allScreen {
  position: fixed;
  background-color: #000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Cover.vue